module.exports = __webpack_public_path__ + "img/ywt_list_img7.314926f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/saasIntroduction/ywt_list_img7.png
// module id = FNeV
// module chunks = 136